import DropDown from '../lib/dropdown';
import Form from '../lib/form';

const CORE = {

	className: 'brtn-alert',

	instances: {
		form: [],

		dropdown: [],
	},

	construct: function () {


		CORE.instances.dropdown = DropDown({
			prefix: 'brtn-alert',
			closeAll: false,
		});

		CORE.instances.form = Form({
			action: 'prd-alert',
			classNames: {
				form: 'brtn-alert',
				message: 'brtn-message'
			},
			reloadOnDone: false,
		});

		return {
			refresh: function () {

				if (typeof CORE.instances.dropdown === 'object' && 'refresh' in CORE.instances.dropdown) {
					CORE.instances.dropdown.refresh();
				}

				if (typeof CORE.instances.form === 'object' && 'refresh' in CORE.instances.form) {
					CORE.instances.form.refresh();
				}

			}
		};

	}

};

export default CORE.construct;